import { Button, ButtonGroup, Dialog, Loading, Switch } from '@/components';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { CustomTable } from '@/components/Table';
import { States } from '@/helpers/common/states';
import EventPos from '@/model/EventPos';
import { SectionPos } from '@/model/SectionPos';
import React, { Fragment } from 'react';
import { Container, Form, FormGroup } from 'reactstrap';
import dayjs from 'dayjs';
import { ReactComponent as Trash } from '@/assets/images/svg/lixeira.svg';
import POSIcon from '@/assets/images/svg/Pos';
import { ActionProps } from '@/components/Dialog';
import Pos from '@/model/Pos';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { columnsPos, ShouldShowModal } from '../../types';
import { RegisterPosContent } from '../../components/RegisterPosContent';

interface StateProps {
  state: States;
  title: string | React.ReactNode;
  visible: boolean;
  shouldShowModal: ShouldShowModal;
  poss: Pos[];
  formData: FormData;
  formErrors: FormErrors;
  allowPos: boolean;
  sections: SectionPos[];
}

interface DispatchProps {
  onToggle: () => void;
  onChangeFormInput: OnChangeFormInput;
  onSavePos: () => void;
  onHasPos: (allowPos: boolean) => void;
  onChangePosSwitch: (sectionId: string, pos: EventPos) => void;
  onShouldShowModal: ({
    value,
    newTitleModal,
    sectionId,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    sectionId: string;
  }) => void;
  onShowDeletePos: (sectionId: string, pos: EventPos) => void;
  backTab: () => void;
}

type Props = StateProps & DispatchProps;

export const SectorPosContainer: React.FC<Props> = ({
  state,
  title,
  visible,
  onToggle,
  shouldShowModal,
  poss,
  formData,
  formErrors,
  onChangeFormInput,
  onSavePos,
  allowPos,
  onHasPos,
  sections,
  onChangePosSwitch,
  onShouldShowModal,
  onShowDeletePos,
  backTab,
}): JSX.Element => {
  const renderActionDialogToCancel: ActionProps = {
    title: 'Cancelar',
    onClick: (): void => {
      onToggle();
    },
    theme: 'noneBorder',
  };
  return (
    <Fragment>
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        isContentWithCard
        actions={[
          {
            [ShouldShowModal.POS]: renderActionDialogToCancel,
          }[shouldShowModal],
          {
            [ShouldShowModal.POS]: {
              title: 'Salvar',
              onClick: () => onSavePos(),
            },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.POS]: (
              <RegisterPosContent
                poss={poss}
                formData={formData}
                onChangeFormInput={onChangeFormInput}
                formErrors={formErrors}
              />
            ),
          }[shouldShowModal]
        }
      </Dialog>
      <Loading isVisible={state === States.loading} />
      <Container className="mainContainer" fluid={true}>
        <h6 className="mb-5">Configurando POS</h6>
        <Form>
          <FormGroup>
            <ButtonGroup
              label="Permitir POS?"
              name="allowPos"
              value={`${allowPos}`}
              onChange={e => onHasPos(e.target.value === 'true')}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
            />
          </FormGroup>
        </Form>

        {sections &&
          sections.length > 0 &&
          sections.map(section => (
            <SuperCollapse
              key={`Pos-Section-${section.id}`}
              title={section.name}
              count={section.poss.length}
              content={
                <Fragment>
                  {section.poss.length > 0
                    ? section.poss.map((eventPos, indexPos) => (
                        <Fragment key={indexPos}>
                          {indexPos > 0 ? <hr style={{ margin: '25px -30px 30px -30px' }} /> : null}
                          <div>
                            <div className="d-flex w-100 justify-content-between">
                              <div className="mb-3 w-100">
                                <span className="secondary-table-title">POS # {indexPos + 1}</span>
                                <span className="secondary-table-title font-weight-bold">
                                  • {eventPos.pos.name}
                                </span>
                              </div>
                              <Switch
                                name={`allowSellingWebsite-${eventPos.allowDiscount}`}
                                label="Aceita desconto?"
                                onChange={() => onChangePosSwitch(section.id, eventPos)}
                                checked={eventPos.allowDiscount}
                              />
                            </div>
                            <CustomTable
                              theme="secondaryWithoutBorder"
                              numberRowsPerPage={0}
                              progressPending={false}
                              columns={columnsPos}
                              data={[
                                {
                                  serialNumber: eventPos.pos.serialNumber,
                                  date:
                                    dayjs(eventPos.bindingDate).format('DD/MM/YYYY') ===
                                    'Invalid Date'
                                      ? '-----'
                                      : dayjs(eventPos.bindingDate).format('DD/MM/YYYY'),
                                  // waiter: `${waiter && (+waiter).toFixed(2)}%`,
                                  // commission: `${commission && (+commission).toFixed(2)}%`,
                                  actions: (
                                    <div>
                                      <Trash
                                        className="svg-icon svg-icon-trash action-icon"
                                        onClick={() => onShowDeletePos(section.id, eventPos)}
                                      />
                                    </div>
                                  ),
                                },
                              ]}
                            />
                          </div>
                        </Fragment>
                      ))
                    : 'Nenhuma POS cadastrada. Aqui será exibida uma lista de POS'}
                  <div className="d-flex justify-content-center">
                    <Button
                      title="Adicionar POS"
                      theme="dark"
                      onClick={() =>
                        onShouldShowModal({
                          value: ShouldShowModal.POS,
                          newTitleModal: 'Adicionar POS',
                          sectionId: section.id,
                        })
                      }
                    />
                  </div>
                </Fragment>
              }
              leftIcon={POSIcon()}
            />
          ))}
        <div className="d-flex justify-content-end">
          <Button title="Voltar etapa" theme="noneBorder" onClick={() => backTab()} />
        </div>
      </Container>
    </Fragment>
  );
};
